"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyService = void 0;
var axios_1 = __importDefault(require("axios"));
var auth_js_1 = require("../../src/utils/auth.js");
var store_1 = __importDefault(require("../../src/store"));
var router_1 = __importDefault(require("../../src/router"));
var ant_design_vue_1 = require("ant-design-vue");
var user_status_service_1 = require("./user-status.service");
axios_1.default.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
var service = axios_1.default.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    // baseURL: process.env.VUE_APP_PROXY,
    baseURL: process.env.VUE_APP_PROXY,
    // 超时
    timeout: 120000
});
//request拦截器
service.interceptors.request.use(function (config) {
    // 是否需要设置 token
    var isToken = (config.headers || {}).isToken === false;
    if ((0, auth_js_1.getToken)() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + (0, auth_js_1.getToken)(); // 让每个请求携带自定义token 请根据实际情况自行修改
        config.headers['sid'] = sessionStorage.getItem('sid');
    }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
        var url = config.url + '?';
        for (var _i = 0, _a = Object.keys(config.params); _i < _a.length; _i++) {
            var propName = _a[_i];
            var value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof (value) !== "undefined") {
                if (typeof value === 'object') {
                    for (var _b = 0, _c = Object.keys(value); _b < _c.length; _b++) {
                        var key = _c[_b];
                        var params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        url += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
                else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});
// FixedParamsService.parentAction.loginOut();
// 响应拦截器
service.interceptors.response.use(function (res) {
    var code = res.data.code;
    // 获取错误信息
    var msg = res.data.message;
    if (code == 'security-session_invalid' || code == 'security-session_sid_not_found') {
        // message.error(msg)
        store_1.default.dispatch('LogOut').then(function () {
            router_1.default.push({ name: 'Login', query: { loginOut: true } });
            setTimeout(function () { window.location.reload(); }, 300);
        });
        window.localStorage.clear();
        window.sessionStorage.clear();
    }
    else if (code != '0' && code != '0000' && res.config.responseType != 'blob' && res.config.responseType != 'arraybuffer') {
        ant_design_vue_1.message.error(msg);
        return Promise.reject(new Error(msg));
        // throw { code: res.data.code, data: res.data.data, message: res.data.message }
    }
    else {
        // 进行判断 是普通对象数据
        if (res.data.type === 'application/json') {
            // 创建一个FileReader实例
            var reader_1 = new FileReader();
            // 读取文件,结果用字符串形式表示
            reader_1.readAsText(res.data, 'utf-8');
            // 读取完成后,**获取reader.result**
            reader_1.onload = function () {
                if (typeof reader_1.result === "string") {
                    var mesg = JSON.parse(reader_1.result).message;
                }
                else {
                    var mesg = '文件下载失败';
                }
                ant_design_vue_1.message.error(mesg);
                return Promise.reject(new Error(mesg));
            };
        }
        else {
            // 文件流处理
            if (res.headers['content-type'] == 'application/octet-stream') {
                downloadFile(res.data, decodeURI(res.headers['content-disposition'].split(";")[1].split("filename=")[1]));
                return;
            }
            return res.data;
        }
    }
    // 未设置状态码则默认成功状态
    // const code = res.data.code || 200;
    // // 获取错误信息
    // const msg = errorCode[code] || res.data.msg || errorCode['default']
    // if (code === 401) {
    // 	Modal.warning({
    // 		title: '你已退出登录，请重新登录',
    // 		okText: '确认', // 设置按钮内容，默认为 OK
    // 		onOk: () => { // 点击确认后的回调
    // 			store.dispatch('LogOut').then(() => {
    // 				location.href = '/';
    // 			})
    // 		}
    // 	  })
    // } else if (code === 500) {
    //   message.error(msg)
    //   return Promise.reject(new Error(msg))
    // }
    // //  else if (code !== 200) {
    // //   notification.error(msg)
    // //   return Promise.reject('error')
    // // } 
    // else {
    //   return res.data
    // }
}, function (error) {
    var msg = error;
    if (msg == "Error: timeout of 120000ms exceeded") {
        msg = "系统接口请求超时";
    }
    // if (msg == "Network Error") {
    // 	msg = "后端接口连接异常";
    // }
    // else 
    // else if (msg.includes("Request failed with status code")) {
    // 	msg = "系统接口" + msg.substr(msg.length - 3) + "异常";
    // }
    ant_design_vue_1.message.error(msg);
    return Promise.reject(error);
});
exports.default = service;
var ProxyService = /** @class */ (function () {
    function ProxyService() {
    }
    ProxyService.post = function (url, params) {
        return new Promise(function (resolve, reject) {
            axios_1.default.post(url, params).then(function (res) {
                if (res['code'] == '0')
                    resolve(res);
                else if (res['code'] == 'security-session_sid_not_found')
                    user_status_service_1.UserStatusService.loginOut();
                else
                    reject(res);
            }, function (err) {
                reject(err);
            }).catch(function (err) {
            });
        });
    };
    ProxyService.get = function (url, params) {
        return new Promise(function (resolve, reject) {
            axios_1.default.get(url, params).then(function (res) {
                if (res['code'] == '0')
                    resolve(res);
                else if (res['code'] == 'security-session_sid_not_found')
                    user_status_service_1.UserStatusService.loginOut();
                else
                    reject(res);
            }, function (err) {
                reject(err);
            }).catch(function (err) {
            });
        });
    };
    // 下载
    ProxyService.export = function (_url, data) {
        if (_url.indexOf('/') === 0) {
            return ("请去除URL前的'/'");
        }
        _url = axios_1.default.defaults.baseURL + _url + '?';
        for (var i in data) {
            _url += i;
            _url += '=';
            _url += data[i];
            _url += '&';
        }
        // _url = _url+'sid='+ this.__header__.sid
        window.open(_url);
    };
    ProxyService.upload = function (url, params) {
        return new Promise(function (resolve, reject) {
            axios_1.default.post(url, params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (res) {
                if (res.status == 0)
                    resolve(res);
                else
                    reject(res);
            }, function (err) {
                reject(err);
            });
        });
    };
    ProxyService.axios = axios_1.default;
    return ProxyService;
}());
exports.ProxyService = ProxyService;
// 文件流转blob对象下载
function downloadFile(data, filename) {
    var blob = new Blob([data]); //创建一个新的 Blob 对象
    var url = window.URL.createObjectURL(blob); //  把一个blob对象转化为一个Blob URL，创建下载链接
    var downloadLink = document.createElement('a'); // 生成一个a标签
    downloadLink.href = url;
    downloadLink.download = filename; // // dowload属性指定下载后文件名
    document.body.appendChild(downloadLink); //将a标签添加到body中
    downloadLink.click(); // 点击下载
    document.body.removeChild(downloadLink); // 下载完成后移除元素
    window.URL.revokeObjectURL(url); // 释放掉blob对象
    ant_design_vue_1.message.success('导出成功！');
}
